export const BlockFunctionConstants = {
  hasSummaryContent: 'hasSummaryContent',
};
